import {Action} from "@ngrx/store";

export const SET_ROLE_LOADED = "[ROLE LOADED] set";

export class SetRoleLoaded implements Action {
    readonly type = SET_ROLE_LOADED;
    constructor(public payload: boolean){
    }
}


export type RoleLoadedActions = SetRoleLoaded;